module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgB7ZbhEYIwDIWj5wCMwAiO4AiMwCa6GWyAG3SU2EiqJUeh4Wjwh99dT02vfc/00hSAQcTKj7sfHZZj8KMFiQ/Wfji0w5FmbMBFEzc/KiiA37cRWhUF20mgMDgedTDxoMDAPxowgrNMdBAOBQzhLLw5BfGTBwwJumdQksrY1kyqDezNBZSkjmrrER6egb+BbAPfa3z5ttRWgyYDPX9eIS0ebtMn5JLrmO7tpZ4h7vg2Y79RV2GgEp2sieK3eA4yUBvgRWvvBpqrM/fSG4gWUwsfIuGOjyi7nYeFv9OM0OAxMgcZ6Pn7FYzAuFxxpbwKiE/LNVVehYTnyxX3e5Y7IZral2L1nEtZXmpWxDtUlqsmxR8DQnz+35YycIi4MGAvLgzYiwsD9uJswG0RfwGa4sjx1Bh0SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/pictosmile.png
// module id = 540
// module chunks = 0